// copied and edited from packages/ui/src/components/FlavorFinder/components/Footer/FlavorFinderFooter.tsx
import type { FC, PropsWithChildren } from "react";
import { useEffect, useRef } from "react";

import classNames from "classnames";

import styles from "./FlavorFinderFooter.module.scss";

type FlavorFinderFooterProps = {
  className?: string;
};

export const FlavorFinderFooter: FC<PropsWithChildren<FlavorFinderFooterProps>> = ({ children, className }) => {
  return <div className={classNames(styles.footer, className)}>{children}</div>;
};

export const FlavorFinderFooterSticky: FC<PropsWithChildren<FlavorFinderFooterProps>> = ({ children, className }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      document.documentElement.style.setProperty(
        "--sticky-container-bottom-height",
        `${entry.target.getBoundingClientRect().height}px`
      );
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty("--sticky-container-bottom-height");
    };
  }, []);

  return (
    <div ref={ref} className={classNames(styles.stickyNav, className)}>
      {children}
    </div>
  );
};
